export const dataRaw = {
  "ASD-GSE-01CR01-PAC002": {
    "Increase Maintenance": 296642,
    "Partial Refurbishment": 307313,
    Replacement: 317985,
  },
  "ASD-GSE-03CR02-PAC003": {
    "Increase Maintenance": 582826,
    "Partial Refurbishment": 536261,
    Replacement: 489695,
  },
  "LSD-MWB-01WK13-PAC004": {
    "Increase Maintenance": 128487,
    "Partial Refurbishment": 144790,
    Replacement: 161092,
  },
};
